/**
 * @generated SignedSource<<491437439374fa12966f4ffbe1434891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATOrganizationTeacherDeleteInput = {
  id: string;
};
export type MATTeacherConnectionDataTable_organizationTeacherDeleteMutation$variables = {
  input: MATOrganizationTeacherDeleteInput;
};
export type MATTeacherConnectionDataTable_organizationTeacherDeleteMutation$data = {
  readonly organizationTeacherDelete: {
    readonly id: string;
  };
};
export type MATTeacherConnectionDataTable_organizationTeacherDeleteMutation = {
  response: MATTeacherConnectionDataTable_organizationTeacherDeleteMutation$data;
  variables: MATTeacherConnectionDataTable_organizationTeacherDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATTeacher",
    "kind": "LinkedField",
    "name": "organizationTeacherDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATTeacherConnectionDataTable_organizationTeacherDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATTeacherConnectionDataTable_organizationTeacherDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfd4a996c5941acce02be311525da8d2",
    "id": null,
    "metadata": {},
    "name": "MATTeacherConnectionDataTable_organizationTeacherDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation MATTeacherConnectionDataTable_organizationTeacherDeleteMutation(\n  $input: MATOrganizationTeacherDeleteInput!\n) {\n  organizationTeacherDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a84e50438cef6a38cef83ae22553879f";

export default node;
